const firebaseConfig = {
    apiKey: "AIzaSyBEx3OisiVRa7SssH0lem_t8TrR8-_Xkrs",
    authDomain: "fir-2dd81.firebaseapp.com",
    projectId: "fir-2dd81",
    storageBucket: "fir-2dd81.appspot.com",
    messagingSenderId: "947602751540",
    appId: "1:947602751540:web:6c195c8a7265117aa4ca61"
};

export default firebaseConfig;